import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../context/AppContext';

const AssetTypeFilterModal = ({ isOpen, onClose, onApply, currentAssetType = '' }) => {
  const { t } = useAppContext();
  const [selectedAssetType, setSelectedAssetType] = useState('');

  // Asset type options
  const assetTypeOptions = [
    { value: '', label: t('telus.modal.assetType.all') },
    { value: 'SVOD', label: t('telus.modal.assetType.svod') },
    { value: 'TVOD', label: t('telus.modal.assetType.tvod') }
  ];

  // Initialize selected asset type when modal opens
  useEffect(() => {
    if (isOpen) {
      setSelectedAssetType(currentAssetType || '');
    }
  }, [isOpen, currentAssetType]);

  const handleRadioChange = (value) => {
    setSelectedAssetType(value);
  };

  const handleApply = () => {
    onApply(selectedAssetType);
    onClose();
  };

  const handleClear = () => {
    setSelectedAssetType('');
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex justify-center items-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        {/* Header */}
        <div className="p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold">{t('telus.modal.assetType.header')}</h2>
        </div>

        {/* Content */}
        <div className="p-4">
          <div className="space-y-3">
            {assetTypeOptions.map((option) => (
              <label key={option.value} className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="assetType"
                  value={option.value}
                  checked={selectedAssetType === option.value}
                  onChange={() => handleRadioChange(option.value)}
                  className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500 mr-3"
                />
                <span className="text-sm text-gray-700">{option.label}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-gray-200 flex justify-between bg-gray-50">
          <button
            onClick={handleClear}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            {t('telus.modal.assetType.clear')}
          </button>
          <div className="space-x-2">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              {t('telus.modal.assetType.cancel')}
            </button>
            <button
              onClick={handleApply}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              {t('telus.modal.assetType.apply')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetTypeFilterModal;
